module.exports = __webpack_public_path__ + "img/护理-4.8ca0c042.png";